
import { ObservationDescription } from "@/utils/carpass/observation-description";
import Vue from "vue";
import AppCarpassObservationDescriptionAddActivity from "./CarpassObservationDescriptionAddActivity.vue";
import AppCarpassObservationDescriptionEditJobDescriptionModal from "./CarpassObservationDescriptionEditJobDescriptionModal.vue";
import { Tire } from "@/utils/carpass/tire";
import AppCarpassObservationDescriptionTireEdit from "./CarpassObservationDescriptionTireEdit.vue";
import { CarpassService } from "@/services/carpass-service";
import { ObservationDescriptionResponse } from "@/utils/carpass/observation-description-response";
import { Sale } from "@/models/base";
import AppCarpassObservationDescriptionResponse from "./CarpassObservationDescriptionResponse.vue";
import { HttpError } from "@/utils/services/http-error";

export default Vue.extend({
	data(){
		return {
			result: new ObservationDescription(),
			addActivityModalOpen: false,
			editJobDescripiontOpen: false,
			toEditJobDescriptionIndex: -1,
			toEditTire: null as null | Tire,
			isPosting: false,
			response: null as null | ObservationDescriptionResponse
		};
	},
	props: {
		sale: {
			type: Object as ()=>Sale,
			required: true
		}
	},
	computed: {
		isValid():boolean {
			return this.result.isValid();
		},
		toEditJobDescriptionValue():string{
			return this.result.jobDescriptions[this.toEditJobDescriptionIndex] || "";
		},
		shouldUseTires():boolean {
			return this.result.shouldHaveTires();
		},
		addTiresDisabled():boolean {
			if (!this.shouldUseTires) return true;
			if (this.result.tyres.length >= 6) return true;
			return false;
		}
	},

	methods: {
		addActivity(){
			this.addActivityModalOpen = true;
		},
		removeActivity(index:number){
			this.result.activities.splice(index, 1);
		},
		removeDescription(index:number){
			this.result.jobDescriptions.splice(index, 1);
		},
		onJobDescriptionInput(val:string){
			if (this.toEditJobDescriptionIndex == -1) {
				this.result.jobDescriptions.push(val);
			}else{
				this.result.jobDescriptions[this.toEditJobDescriptionIndex] = val;
			}
		},
		closeJobDescriptionEdit(){
			this.editJobDescripiontOpen = false;
			this.toEditJobDescriptionIndex = -1;
		},
		addJobDescription(){
			this.toEditJobDescriptionIndex = -1;
			this.editJobDescripiontOpen = true;
		},
		removeJobDescription(i:number){
			this.result.jobDescriptions.splice(i, 1);
		},
		editJobDescription(i:number){
			this.toEditJobDescriptionIndex = i;
			this.editJobDescripiontOpen = true;
		},
		addTire(){
			this.toEditTire = new Tire();
		},
		onTire(t:Tire){
			if (!this.toEditTire) return;
			let i = this.result.tyres.indexOf(this.toEditTire);
			if (i == -1) {
				this.result.tyres.push(t);
			}else{
				this.result.tyres[i] = t;
			}
		},
		editTire(t:Tire){
			this.toEditTire = t;
		},
		removeTire(i:number){
			this.result.tyres.splice(i, 1);
		},
		cancel(){
			this.$emit("close");
		},
		async confirm(){
			if (this.isPosting) return;
			try{
				let response = await CarpassService.postObservationDescription(this.sale, this.result);
				if (response.errors.length == 0) {
					this.$emit("close");
					return;
				}
				this.response = response;
			}catch(err){
				let hErr = err as HttpError;
				if (!hErr.data) return;
				this.response = new ObservationDescriptionResponse(JSON.parse(hErr.data[0].replace("StatusCode = 400: ", "")));
			}finally{
				this.isPosting = false;
			}
		}
	},

	components: {
		AppCarpassObservationDescriptionAddActivity,
		AppCarpassObservationDescriptionEditJobDescriptionModal,
		AppCarpassObservationDescriptionTireEdit,
		AppCarpassObservationDescriptionResponse
	},
	i18nEx: {
		componentPrefix: "components.cars"
	}
});
